<template>
  <div class="hero">
    <div class="hero__main" :class="classes">
      <div class="hero__intro">
        <div class="hero__label" v-if="info.label" v-html="info.label" />
        <div class="hero__heading" v-if="info.title" v-html="info.title" />
        <h1 class="hero__leading" v-if="info.excerpt" v-html="info.excerpt" />
      </div>
    </div>
    <div class="hero__figure" v-if="imageDesktop?.url">
      <div class="hero__overlay" :style="{ opacity: block.data?.overlay }" />
      <img class="hero__image hidden sm:block" :src="imageDesktop.url" :alt="imageDesktop.alt" />
      <img class="hero__image sm:hidden" :src="imageMobile?.url ?? imageDesktop.url" :alt="imageMobile?.alt ?? imageDesktop.alt" />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  block: Object
})

// block.data?.alignText: string
// block.data?.fullHeight: boolean
// block.data?.alignContent: string

const info = {
  'label': props.block.data?.label,
  'title': props.block.data?.title,
  'excerpt': props.block.data?.excerpt,
}

const imageMobile = props.block?.data?.imageMobile
const imageDesktop = props.block?.data?.imageDesktop

const classes = [
  'layout-' + props.block?.data?.layout,
  'align-text-' + props.block?.data?.alignText,
  'align-content-' + props.block?.data?.alignContent,
  // props.block?.data?.alignText === 'center' ? 'is-center' : '',
  // props.block?.data?.alignText === 'left' ? 'is-left' : '',
  // props.block?.data?.fullHeight
  //   ? 'is-fullscreen' 
  //   : props.block?.data?.layout === 'featured'
  //     ? 'is-featured'
  //     : 'is-standard',
  // props.block?.data?.alignText 
  //   ? props.block?.data?.alignText === 'center'
  //     ? 'text-center' 
  //     : props.block?.data?.alignText === 'right' 
  //       ? 'text-right' 
  //       : null
  // : null,
  // props.block?.data?.alignContent 
  //   ? props.block?.data?.alignContent === 'top'
  //     ? 'items-start' 
  //     : props.block?.data?.alignContent === 'bottom' 
  //       ? 'items-end' 
  //         : 'items-center' 
  // : null,
].filter(str => str).join(' ')
</script>

<style lang="scss" scoped>
.hero {
  /*
  @apply relative left-1/2 right-1/2 w-screen -ml-[50vw];
  @apply bg-black mb-4;
  */

  @apply relative mb-4;
  // @apply rounded overflow-hidden;
  // @apply left-1/2 right-1/2 w-screen -ml-[50vw];
  @apply -mx-[4vw] -mt-2;

  @screen lg {
    @apply mx-0 mt-0;
    @apply rounded overflow-hidden;
    // @apply mt-8 rounded overflow-hidden;
    @apply left-auto right-auto w-full mx-auto;
  }

  &.is-first.is-root {
    // @apply mt-0;
  }
  
  &.is-first { }

  &.is-last { }

  &__main {
    @apply flex items-center max-w-7xl px-[4vw] py-12 md:py-[4vw] mx-auto;
    @apply relative z-20 text-white;

    // @screen lg {
    //   padding-left: 16rem;
    // }

    // @screen 3xl {
    //   // padding-left: [8vw];
    //   padding-left: 0;
    // }

    &.align-text-center {
      @apply text-center mx-auto;
      // max-width: 20%;
      // @apply mx-auto;
      // max-width: 64ch; // Todo: Fix prose max width 
    }

    &.align-content-top {
      @apply items-start;
    }

    &.align-content-bottom {
      @apply items-end;
      // max-width: 20%;
      // @apply mx-auto;
      // max-width: 64ch; // Todo: Fix prose max width 
    }

    &.layout-standard {
      @apply min-h-[10rem] md:min-h-[14rem];
    }

    &.layout-featured {
      // @apply py-10 md:py-20;
      @apply min-h-[130vw] sm:min-h-[32rem]; // md:h-[40vh] max-h-[60rem];
    }

    &.layout-fullscreen {
      // @apply py-20 md:py-28;
      // @apply max-h-[64rem];
      // height: calc(100vh - 3.5rem);
    }
  }

  &__intro {
    @apply w-full;
    @apply grid gap-2;
    // @apply my-4 md:my-6;
    // @apply p-[4vw];
    // @apply text-center mx-auto;
  }

  &__label {
    @apply font-bold uppercase tracking-[0.25em];
  }

  &__heading {
    @apply font-heading font-bold;
    @apply text-5xl sm:text-6xl lg:text-7xl xl:text-8xl;
  }

  &__leading {
    @apply font-heading font-medium;
    @apply text-xl lg:text-2xl xl:text-3xl;
  }

  &__blocks {
    // @include box(#ccc);
    @apply max-w-3xl;

    /*
    &:deep(.h1) {
      @apply text-[#{44 * 0.0625rem}] md:text-[#{64 * 0.0625rem}];
    }

    &:deep(.h2) {
      @apply text-[#{32 * 0.0625rem}] md:text-[#{54 * 0.0625rem}];
    }

    &:deep(.h3) {
      @apply text-[#{28 * 0.0625rem}] md:text-[#{44 * 0.0625rem}];
    }

    &:deep(.h4) {
      @apply text-[#{24 * 0.0625rem}] md:text-[#{36 * 0.0625rem}];
    }

    &:deep(.h5),
    &:deep(.h6) {
      @apply text-[#{18 * 0.0625rem}] md:text-[#{20 * 0.0625rem}];
    }

    &:deep(.lead) {
      @apply mt-4;
    }

    &:deep(.base) {
      @apply mt-4;
    }

    &:deep(.meta) {
      @apply mt-4;
    }

    &:deep(.mini) {
      @apply mt-4;
    }
    */
  }

  &__figure {
    @apply absolute z-10 top-0 left-0 w-full h-full bg-black overflow-hidden; 
  }

  &__overlay {
    @apply absolute z-10 top-0 left-0 w-full h-full bg-black overflow-hidden pointer-events-none;
  }

  &__image {
    @apply w-full h-full object-cover;
  }
}
</style>